import { render, staticRenderFns } from "./CockpitConfiguration.vue?vue&type=template&id=3338104e"
import script from "./CockpitConfiguration.vue?vue&type=script&lang=js"
export * from "./CockpitConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports